module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [(_vm.toast) ? _h('mu-toast', {
    attrs: {
      "message": _vm.toastmessage
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), " ", _h('mu-drawer', {
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked
    },
    on: {
      "close": function($event) {
        _vm.toggle()
      }
    }
  }, [_h('mu-list', {
    on: {
      "itemClick": function($event) {
        _vm.docked ? '' : _vm.toggle()
      }
    }
  }, [_h('mu-menu-item', {
    attrs: {
      "title": "使用說明"
    },
    on: {
      "click": _vm.openAction
    }
  }), " ", (!_vm.currentUser) ? _h('mu-menu-item', {
    attrs: {
      "title": "FB登入"
    },
    on: {
      "click": _vm.fbSignIn
    }
  }) : _vm._e(), " ", (!_vm.currentUser) ? _h('mu-menu-item', {
    attrs: {
      "title": "Google登入"
    },
    on: {
      "click": _vm.signIn
    }
  }) : _vm._e(), " ", (_vm.currentUser) ? _h('mu-menu-item', {
    attrs: {
      "title": "登出"
    },
    on: {
      "click": _vm.signOut
    }
  }) : _vm._e(), " ", _h('mu-menu-item', {
    attrs: {
      "title": ""
    }
  }), " ", _h('mu-menu-item', {
    attrs: {
      "title": "正常版"
    },
    on: {
      "click": function($event) {
        _vm.loadProduct(0)
      }
    }
  }), " ", _h('mu-menu-item', {
    attrs: {
      "title": "歡樂測試版"
    },
    on: {
      "click": function($event) {
        _vm.loadProduct(2)
      }
    }
  }), " ", _h('mu-menu-item', {
    attrs: {
      "title": "",
      "href": "/#/chatPage"
    }
  })])]), " ", _h('mu-appbar', [_h('mu-icon-button', {
    attrs: {
      "icon": "menu"
    },
    on: {
      "click": function($event) {
        _vm.toggle(true)
      }
    },
    slot: "left"
  }), " ", _h('mu-sub-header', [_h('h1', ["地圖佈告欄"])]), " ", (!_vm.currentUser) ? _h('mu-flat-button', {
    attrs: {
      "color": "white",
      "label": "Login"
    },
    on: {
      "click": _vm.fbSignIn
    },
    slot: "right"
  }) : _vm._e(), " ", (_vm.currentUser) ? _h('mu-flat-button', {
    attrs: {
      "color": "white",
      "label": _vm.currentUser.displayName
    },
    on: {
      "click": function($event) {}
    },
    slot: "right"
  }) : _vm._e()]), " ", _h('div', {
    attrs: {
      "id": "map"
    }
  }), " ", _h('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [(_vm.currentUser && _vm.wantSell) ? _h('div', [_h('h1', ["在這裡寫下你想做的事吧"]), " ", _h('mu-content-block', [_h('div', {
    staticClass: "demo-grid"
  }, [_h('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "上傳圖片"
    }
  }, [_h('input', {
    staticClass: "file-button",
    attrs: {
      "accept": "image/*,capture=camera",
      "type": "file"
    },
    on: {
      "change": _vm.saveImageMessage
    }
  })]), _h('br'), " ", (_vm.isUpload) ? _h('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  }) : _vm._e(), _h('br'), " ", (_vm.productPhoto) ? _h('mu-card-media', [_h('img', {
    staticClass: "product-photo",
    attrs: {
      "src": _vm.productPhoto
    }
  })]) : _vm._e(), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "label": "標題(物品，服務等)",
      "type": "text",
      "errorText": (!_vm.title) ? '不可空白' : '',
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        _vm.title = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.price),
      expression: "price"
    }],
    attrs: {
      "label": "費用",
      "type": "number",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.price)
    },
    on: {
      "input": function($event) {
        _vm.price = _vm._n($event)
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "hintText": "敘述你的物品或服務內容吧，如：尺寸，顏色",
      "multiLine": "",
      "rows": 4
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        _vm.description = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    attrs: {
      "label": "概略地點 (optional)",
      "type": "text",
      "hintText": "如：台北市大安區",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        _vm.address = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "label": "關鍵字 (optional)",
      "type": "text",
      "hintText": "逗點分隔關鍵字，如：nike,puma...",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        _vm.keywords = $event
      }
    }
  }), _h('br'), " ", _h('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "送出",
      "primary": ""
    },
    on: {
      "enter": function($event) {
        _vm.addProduct(0)
      },
      "click": function($event) {
        _vm.addProduct(0)
      }
    }
  }), " ", _h('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "歡樂測試版",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.addProduct(2)
      }
    }
  })])]), " ", _h('mu-content-block', [_h('h3', ["預覽："]), " ", _h('mu-card', [_h('mu-card-media', [_h('img', {
    staticClass: "product-photo",
    attrs: {
      "src": _vm.productPhoto
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": _vm.title,
      "subTitle": (_vm.price) ? ' NT$' + _vm.price : ''
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, [_h('pre', [_vm._s(_vm.description)]), "\n\t                " + _vm._s((_vm.address) ? '地點：' + _vm.address : '') + "\n\t              "]), " ", (_vm.keywords.length > 0) ? _h('mu-card-text', {
    staticClass: "text-align-left"
  }, [_vm._l((_vm.keywords.split(',')), function(keyword) {
    return _h('div', [_h('span', [_h('a', {
      attrs: {
        "href": '#' + keyword
      }
    }, ["#" + _vm._s(keyword)])])])
  })]) : _vm._e(), " ", _h('mu-card-header', {
    attrs: {
      "title": "剛剛建立",
      "subTitle": '來自 ' + _vm.currentUser.displayName
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.currentUser.photoURL
    },
    slot: "avatar"
  })]), " ", _h('mu-sub-header', {
    staticStyle: {
      "color": "#f1efef"
    }
  }, ["(" + _vm._s(_vm.point.lat) + " " + _vm._s(_vm.point.lng) + ")"])])])]) : (_vm.products[_vm.geokey]) ? _h('div', [_h('h1', ["這裡有塊板子上面寫著："]), " ", _h('mu-card', [_h('mu-card-media', [_h('img', {
    staticClass: "product-photo",
    attrs: {
      "src": _vm.products[_vm.geokey].productPhoto
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": _vm.products[_vm.geokey].title,
      "subTitle": (_vm.products[_vm.geokey].price) ? ' NT$' + _vm.products[_vm.geokey].price : ''
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, [_h('pre', [_vm._s(_vm.products[_vm.geokey].description)]), "\n                " + _vm._s((_vm.products[_vm.geokey].address) ? '地點：' + _vm.products[_vm.geokey].address : '') + "\n              "]), " ", (this.products[this.geokey].keywords.length > 0) ? _h('mu-card-text', {
    staticClass: "text-align-left"
  }, [_vm._l((_vm.splitArray), function(keyword) {
    return _h('div', [_h('span', [_h('a', {
      attrs: {
        "href": '#' + keyword
      }
    }, ["#" + _vm._s(keyword)])])])
  })]) : _vm._e(), " ", _h('mu-card-header', {
    attrs: {
      "title": _vm.productCreateTime + ' 前建立',
      "subTitle": '來自 ' + _vm.products[_vm.geokey].userName
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.products[_vm.geokey].userPhotoUrl
    },
    slot: "avatar"
  })]), " ", _h('mu-card-actions', [(!_vm.currentUser || _vm.currentUser.uid !== _vm.products[_vm.geokey].userUid) ? _h('mu-raised-button', {
    attrs: {
      "label": '丟訊息問問 ' + _vm.products[_vm.geokey].userName
    },
    on: {
      "click": function($event) {
        _vm.gossimOpen(_vm.products[_vm.geokey].userUid, _vm.products[_vm.geokey].userName)
      }
    }
  }) : _vm._e(), (!_vm.currentUser || _vm.currentUser.uid !== _vm.products[_vm.geokey].userUid) ? _h('span', ["(此人" + _vm._s(_vm.products[_vm.geokey].userLoginStatus ? '在線上' : '離線') + ")"]) : _vm._e()]), " ", (_vm.currentUser && _vm.currentUser.uid === _vm.products[_vm.geokey].userUid) ? _h('mu-card-actions', [_h('mu-raised-button', {
    attrs: {
      "label": "移動你的板子後，儲存位置。"
    },
    on: {
      "click": function($event) {
        _vm.updateProductLocation(_vm.geokey)
      }
    }
  }), _h('br'), _h('br'), " ", _h('mu-raised-button', {
    attrs: {
      "label": "刪除這塊留言板。",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteProduct(_vm.geokey)
      }
    }
  })]) : _vm._e(), " ", _h('mu-sub-header', {
    staticStyle: {
      "color": "white"
    }
  }, ["位於 " + _vm._s(_vm.point.lat) + " " + _vm._s(_vm.point.lng)])])]) : _vm._e(), " ", " ", " ", _h('mu-popup', {
    attrs: {
      "popupClass": "demo-popup-bottom",
      "open": _vm.bottomPopup
    },
    on: {
      "close": _vm.closeAction
    }
  }, [_h('mu-appbar', {
    attrs: {
      "title": "使用說明"
    }
  }, [_h('mu-flat-button', {
    attrs: {
      "label": "關閉",
      "color": "white"
    },
    on: {
      "click": _vm.closeAction
    },
    slot: "right"
  })]), " ", _h('mu-content-block', [_h('h3', ["操作方式："]), " ", _h('p', ["\n          未登入時，可觀看附近的留言板。\n          登入時，可任意在地圖上加入，移動，刪除留言板。\n          可與對方私訊交談，即使對方不在線上也會寄信通知。\n        "]), " ", _h('h3', ["作者："]), " ", _h('p', ["\n          Created by ", _h('a', {
    attrs: {
      "href": "https://www.facebook.com/yijuwu"
    }
  }, ["Mark"]), ".", _h('br'), "\n          連結", _h('a', {
    attrs: {
      "href": "https://www.facebook.com/yijuwu"
    }
  }, ["https://www.facebook.com/yijuwu"]), _h('br'), "\n          有任何問題或改進方案都可以提供給我，謝謝！\n        "])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0982f51a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/MapPage.vue
// module id = 90
// module chunks = 2